module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/demo4/footer-c583e5862b91f7a969665212d6a91170.jpg";